import { useQuery } from "@tanstack/react-query";

import { useIsIndustryTaxonomyOptedIn } from "../hooks/useIsIndustryTaxonomyOptedIn";

import { createCrmJobsTransitionQuery } from "./options";

export default function useCrmJobsTransitionQuery() {
    const isIndustryTaxonomyOptedIn = useIsIndustryTaxonomyOptedIn();

    return useQuery(
        createCrmJobsTransitionQuery({
            enabled: isIndustryTaxonomyOptedIn,
        }),
    );
}
